var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1111_82)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4319 24.0001H8.00335C3.43192 24.0001 2.28906 22.8573 2.28906 18.2859V9.143C2.28906 4.57157 3.43192 3.42871 8.00335 3.42871H19.4319C24.0033 3.42871 25.1462 4.57157 25.1462 9.143V18.2859C25.1462 22.8573 24.0033 24.0001 19.4319 24.0001Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 2.05714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.002 9.14258H21.7162",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 2.05714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1426 13.7148H21.714",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 2.05714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4316 18.2871H21.7174",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 2.05714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71506 12.9028C10.8575 12.9028 11.7836 11.9766 11.7836 10.8342C11.7836 9.69176 10.8575 8.76562 9.71506 8.76562C8.57262 8.76562 7.64648 9.69176 7.64648 10.8342C7.64648 11.9766 8.57262 12.9028 9.71506 12.9028Z",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 2.05714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7168 18.6631C13.5568 17.006 12.2425 15.7031 10.5854 15.5546C10.0139 15.4974 9.43108 15.4974 8.84823 15.5546C7.19108 15.7146 5.8768 17.006 5.7168 18.6631",
    stroke: "currentColor",
    strokeOpacity: 0.8,
    strokeWidth: 2.05714,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_82"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.4286,
    height: 27.4286,
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.5da205ddd2ef72bef473c035da3425b6.svg";
export { ForwardRef as ReactComponent };